<template>
  <v-menu
    v-model="open"
    location="bottom right"
    :open-on-hover="shouldOpenOnHover"
  >
    <template #activator="{ props: hover }">
      <DpplDropdownButton
        v-if="type === 'button' && subMenuOptions"
        :class="{ 'ml-4': margin }"
        small
        fab
        depressed
        :disabled="loading || disabled"
        :block="null"
        :is-active="open"
        v-bind="hover"
      >
        <slot />
      </DpplDropdownButton>

      <DpplChip
        v-if="type === 'chip' && subMenuOptions"
        v-bind="{ ...hover, ...$attrs }"
        :class="{ 'ml-4': margin }"
        :arrow="Boolean(subMenuOptions.length)"
        :disabled="loading || disabled"
        :is-active="open"
        @click="$emit('chip-click')"
      >
        <template #label>
          <slot name="label">
            <v-icon
              v-if="prependIcon"
              :icon="prependIcon"
              color="currentColor"
              class="mr-1"
            />
            <div class="p6">
              {{ selectedOption }}
            </div>
          </slot>
        </template>
      </DpplChip>
    </template>

    <v-list
      v-if="subMenuOptions.length"
      density="compact"
    >
      <v-list-item
        v-for="(option) in subMenuOptions"
        :key="option.id"
        class="menu-list-item text-left text-body-2"
        @click="$emit('submitSubMenu', option.id)"
      >
        {{ option.value }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import DpplChip from '@/components/datapeople/DpplChip.vue';
import DpplDropdownButton from '@/components/datapeople/DpplDropdownButton.vue';

export default {
  name: 'DpplSubMenu',
  components: {
    DpplChip,
    DpplDropdownButton,
  },
  props: {
    type: {
      default: 'chip',
      type: String,
    },
    subMenuOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedOption: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    shouldOpenOnHover: {
      type: Boolean,
      default: true,
    },
    prependIcon: {
      type: String,
      default: '',
    },
  },
  emits: ['submitSubMenu', 'chip-click'],
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style lang="less" scoped>
@import '@/less/mixins';
.v-menu__content {
  .shadow();
}
.menu-list-item.v-list-item {
  color: @text-darkest;
  min-height: 40px;
  height: 40px;
  white-space: nowrap;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;

  &:not(:last-child) {
    border-bottom: 1px solid @stroke-default;
  }
}

.menu-list-item.v-list-item:hover {
  background: @bg-brand-light;

  > :deep(.v-list-item__overlay) {
    background: @bg-brand-light;
  }

  :deep(.v-list-item__content) {
    color: @text-brand;
  }
}

.v-menu > .v-overlay__content > .v-list {
  box-shadow: 0 10px 50px 0 fade(@text-darkest, 10%);
  border-radius: 6px;
  padding: 0 !important;
}

.v-chip:hover {
  background: @bg-brand-default !important;
  color: @white !important;
}

.v-chip :deep(.v-chip__overlay) {
  display: none;
}
</style>
